<!--财务中心 客户结算-->
<template>
  <div>
    <el-row v-if="activeName == 'TCBalanceList'">
      <el-col>
        <el-form :model="searchForm1" ref="searchForm1" :inline="true" size="medium">
          <el-form-item label="团餐公司：">
            <el-select filterable v-model="searchForm1.tc_name" placeholder="请选择" :clearable="true">
              <el-option v-for="item in tcName" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份：">
            <el-date-picker v-model="searchForm1.MONTH" type="month" placeholder="选择月份" :clearable="true"
              format="yyyy 年 MM 月" value-format="yyyy-MM"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable1">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="exportData1" v-if="fun_dic[115020102]">日结算数据导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain icon="el-icon-download" @click="exportDoc" style="margin-bottom: 10px"
                       v-if="fun_dic[115020101]">
              导出对账单
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row v-if="activeName == 'customerBalance'">
      <el-col>
        <el-form :model="searchForm2" ref="searchForm2" :inline="true" size="medium">
          <el-form-item label="客户：">
            <el-select filterable v-model="searchForm2.customerName" placeholder="请选择" :clearable="true">
              <el-option v-for="item in customer" :key="item.TC_ID" :label="item.NAME" :value="item.TC_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份：">
            <el-date-picker v-model="searchForm2.MONTH" type="month" :clearable="true" placeholder="选择日期"
              format="yyyy 年 MM 月" value-format="yyyy-MM">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable2">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="exportData2" v-if="fun_dic[115020102]">日结算数据导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row v-if="activeName == 'supplierCustomer'">
      <el-col>
        <el-form :model="searchForm3" ref="searchForm3" :inline="true" size="medium">
          <el-form-item label="客户：">
            <el-select filterable v-model="searchForm3.GYS_ID" placeholder="请选择" :clearable="true">
              <el-option v-for="item in supplierCustomerList" :key="item.value" :label="item.AB_NAME"
                :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份：">
            <el-date-picker v-model="searchForm3.MONTH" type="month" :clearable="true" placeholder="选择日期"
              format="yyyy 年 MM 月" value-format="yyyy-MM">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable3(0)">筛选</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" plain @click="exportData3" v-if="fun_dic[115020102]">日结算数据导出</el-button>
          </el-form-item> -->
        </el-form>
      </el-col>
    </el-row>
    <el-row v-if="activeName == 'customerBalance'">
      <el-col :span="4">
        <span>总收入：{{ totalFee }}元</span>
      </el-col>
      <el-col :span="4">
        <span>总成本：{{ totalCost }}元</span>
      </el-col>
      <el-col :span="4">
        <span>总利润：{{ realMoney }}元</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="团餐公司结算" name="TCBalanceList" lazy>
          <V-TCBalanceListVue ref="TCBalanceList" :search-form1="searchForm1" :current-page1="currentPage1" v-if="flag"
            @tcNameChange="getTcName($event)">
          </V-TCBalanceListVue>
        </el-tab-pane>
        <el-tab-pane label="自录客户结算" name="customerBalance" lazy>
          <V-CustomerBalance ref="customerBalance" :search-form2="searchForm2" :current-page2="currentPage2" v-if="flag"
            @dataChange="getData($event)" @customerChange="getCustomer($event)">
          </V-CustomerBalance>
        </el-tab-pane>
        <el-tab-pane label="供应商客户结算" name="supplierCustomer">
          <el-row>
            <el-col>
              <el-table border stripe :data="tableData" show-summary style="margin-top: 20px">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="SUPPLIER_CLIENT_NAME" label="客户名称"></el-table-column>
                <el-table-column prop="MONTH" label="月份"></el-table-column>
                <el-table-column prop="ORDER_COUNT" label="订单数量"></el-table-column>
                <el-table-column prop="PRODUCT_FEE" label="结算金额" min-width="100"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button size="small" icon="el-icon-view" @click="detail(scope.row)" type="text">查看</el-button>
                    <el-button size="small" icon="el-icon-view" @click="invoiceDetail(scope.row)" type="text">
                      开票明细
                    </el-button>
                    <el-button size="small" icon="el-icon-download" @click="exportData(scope.row)" type="text">
                      导出
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="24" style="text-align: right">
              <el-pagination @current-change="doQueryTable3(currentPage3 - 1)" :current-page.sync="currentPage3"
                :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
              </el-pagination>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import { getActionFun } from '@/assets/api/login';
import VTCBalanceListVue from './TCBalanceList';
import VCustomerBalance from './customerBalance';
import date from '@/assets/common/date';
import { supplierCusFun } from '@/assets/api/customerManage';
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    const lm = Number(new Date().getMonth()); const d = 24 * 60 * 60 * 1000;
    const lastMonth = new Date() - ([4, 6, 9, 11].includes(lm) ? 30 * d : lm == 2 ? 28 * d : 31 * d);
    return {
      PAGE_ID: '1150201',
      fun_dic: { 115020101: 0, 115020102: 0 },
      activeName: 'TCBalanceList',
      tabActiveName: sessionStorage.getItem('customerSettlementTabActiveName'),
      active: ['TCBalanceList', 'customerBalance', 'supplierCustomer'],
      searchForm1: {},
      tcName: [],
      currentPage1: 1,
      flag: false,
      tempList: [],
      searchForm2: { MONTH: date(lastMonth, '%F').slice(0, 7) },
      customer: [],
      currentPage2: 1,
      totalFee: 0,
      totalCost: 0,
      realMoney: 0,
      tempObj: {},
      supplierCustomerList: [],
      tableData: [],
      currentPage3: 1,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      searchForm3: {},

    };
  },
  components: {
    VTCBalanceListVue,
    VCustomerBalance,
  },
  created() {
    this.tabActive();
    this.queryBeforeFun();
  },
  mounted() {
    this.handleClick();
  },
  computed: {
    ORDER_LIST_SEARCH_CONDITION() {
      return this.$store.state.ORDER_LIST_SEARCH_CONDITION;
    },
    NEW_ORDER_SEARCH_DATA_CONDITION() {
      return this.$store.state.NEW_ORDER_SEARCH_DATA_CONDITION;
    },
    SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION() {
      return this.$store.state.SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION;
    },
  },
  methods: {
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    handleClick(tab, event) {
      sessionStorage.setItem('customerSettlementTabActiveName', this.activeName);
      switch (this.activeName) {
        case 'TCBalanceList':
          if (this.ORDER_LIST_SEARCH_CONDITION.CONDITION) {
            this.searchForm1 = this.ORDER_LIST_SEARCH_CONDITION.CONDITION;
            this.currentPage1 = this.ORDER_LIST_SEARCH_CONDITION.CURRENT_PAGE;
          } else {
            this.currentPage1 = 1;
          }
          this.flag = true;
          this.$nextTick(async () => {
            await this.$refs.TCBalanceList.queryTCName();
            await this.$refs.TCBalanceList.queryData();
            this.$nextTick(() => {
              this.tcName = this.tempList;
            });
          });
          break;

        case 'customerBalance':
          if (this.NEW_ORDER_SEARCH_DATA_CONDITION.CONDITION) {
            this.searchForm2 = this.NEW_ORDER_SEARCH_DATA_CONDITION.CONDITION;
            this.currentPage2 = this.NEW_ORDER_SEARCH_DATA_CONDITION.CURRENT_PAGE;
          } else {
            this.currentPage2 = 1;
          }
          this.flag = true;
          this.$nextTick(async () => {
            await this.$refs.customerBalance.queryName();
            await this.$refs.customerBalance.queryData();
            this.$nextTick(() => {
              this.customer = this.tempList;
              this.totalFee = this.tempObj.totalFee;
              this.totalCost = this.tempObj.totalCost;
              this.realMoney = this.tempObj.realMoney;
            });
          });
          break;
        case 'supplierCustomer':
          if (this.SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION.CONDITION) {
            this.searchForm3 = this.SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION.CONDITION;
            this.totalCount = this.SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION.TOTAL_COUNT;
            this.currentPage3 = this.SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION.CURRENT_PAGE;
          }
          this.querySupplierList();
          this.doQueryTable3(this.currentPage3 - 1);
          break;
        default:
          break;
      }
    },
    tabActive() {
      const flag = this.active.find((item) => {
        if (this.tabActiveName == item) {
          return true;
        }
      });
      if (flag) {
        this.activeName = this.tabActiveName;
      }
    },
    // **********团餐公司结算 开始**********
    // 搜索
    doQueryTable1() {
      this.$refs.TCBalanceList.doQueryTable();
    },
    // 日结算数据导出
    exportData1() {
      this.$refs.TCBalanceList.exportData();
    },
    exportDoc() {
      this.$refs.TCBalanceList.exportFormVisible = true;
    },
    getTcName(data) {
      this.tempList = data;
    },
    // **********团餐公司结算 结束**********
    // **********自录客户结算 开始**********
    // 搜索
    doQueryTable2() {
      this.$refs.customerBalance.doQueryTable();
    },
    // 日结算数据导出
    exportData2() {
      this.$refs.customerBalance.exportData();
    },
    getData(data) {
      this.tempObj = data;
    },
    getCustomer(data) {
      this.tempList = data;
    },
    // **********自录客户结算 结束**********
    querySupplierList() {
      const params = {};
      supplierCusFun(params).then((res) => {
        if (res.length !== 0) {
          this.supplierCustomerList = res[0].list;
        } else {
          this.supplierCustomerList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    doQueryTable3(PAGE_INDEX) {
      if (!PAGE_INDEX) {
        this.currentPage3 = 1;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 90,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX,
      };
      for (const key in this.searchForm3) {
        if (Object.prototype.toString.call(this.searchForm3[key]) === '[object Array]') {
          if (this.searchForm3[key][0]) {
            params[key] = this.searchForm3[key];
          }
        } else {
          if (this.searchForm3[key]) {
            params[key] = this.searchForm3[key];
          }
        }
      }
      http.post(params).then((res) => {
        if (res[0]) {
          this.tableData = res[0].DATA_LIST;
          this.totalCount = res[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION', {
            CONDITION: this.searchForm3,
            CURRENT_PAGE: this.currentPage3,
            TOTAL_COUNT: this.totalCount,
          });
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    detail({ GYS_ID, MONTH }) {
      this.$router.push({ path: '/supplierCustomerOrderList/detail' });
      sessionStorage.setItem('supplierCustomerOrderListParams', JSON.stringify({ GYS_ID, MONTH }));
    },
    invoiceDetail({ GYS_ID, MONTH }) {
      this.$router.push({ path: '/supplierCustomerInvoiceDetails/detail' });
      sessionStorage.setItem('supplierCustomerInvoiceDetailsParams', JSON.stringify({ GYS_ID, MONTH }));
    },
    exportData({ GYS_ID, MONTH }) {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 32,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        GYS_ID,
        MONTH,
      };
      http.post(params).then((res) => {
        try {
          window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
        } catch (err) {
          this.$message.show({ text: err, type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/financeCenter/customerSettlement.vue